import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const defaultTypes = [
  { title: "Houses", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/c7f45ade7_generated_image.png" },
  { title: "Apartments", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/6fc84fcac_generated_image.png" },
  { title: "Luxury and unique", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/5b3a2228e_generated_image.png" },
  { title: "Apartment blocks", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/87bca0759_generated_image.png" },
];

const defaultAreas = [
  "Ancoats", "Northern Quarter", "Deansgate", "Spinningfields",
  "Castlefield", "Didsbury", "Chorlton", "Fallowfield",
  "Salford", "Stockport", "Trafford", "Altrincham",
  "Sale", "Bury", "Bolton",
];

const defaultResources = [
  { title: "How much can you earn from Airbnb?", href: "/resources/airbnb-earnings-manchester" },
  { title: "Long-let vs short-let: which earns more?", href: "/resources/long-let-vs-short-let" },
  { title: "What does a short-let management company do?", href: "/resources/what-is-short-let-management" },
];

export default function ManchesterPropertyTypes({ config }) {
  const types = config?.propertyTypes || defaultTypes;
  const AREAS = config?.areas || defaultAreas;
  const resources = config?.resources || defaultResources;
  const cityName = config?.cityName || "Manchester";
  return (
    <section style={{ backgroundColor: "#FFFFFF", padding: "clamp(48px,6vw,72px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Property types: compact row */}
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 16, marginTop: 0 }}>Property types</p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14, marginBottom: 48 }} className="pt-grid">
          {types.map(({ title, image }) => (
            <div key={title} style={{ borderRadius: 12, overflow: "hidden", position: "relative", height: 160 }}>
              <img src={image} alt={title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", position: "absolute", inset: 0 }} />
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 60%)" }} />
              <p style={{ position: "absolute", bottom: 14, left: 16, right: 16, fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 15, color: "#fff", margin: 0, letterSpacing: "-0.01em" }}>{title}</p>
            </div>
          ))}
        </div>

        {/* Service area — between property types and resources */}
        <div style={{ marginBottom: 48 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
            <h3 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 18, color: "#112215", margin: 0, letterSpacing: "-0.01em" }}>We cover all of {cityName}</h3>
            <Link to="/locations" style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 500, color: "#5C7268", textDecoration: "none", display: "flex", alignItems: "center", gap: 4, whiteSpace: "nowrap" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#112215")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#5C7268")}>
              See full coverage <ArrowRight size={13} />
            </Link>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }} className="sa-tags">
            {AREAS.map((name) => (
              <span key={name} style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 500, color: "#5C7268", background: "#F4F1E7", border: "1px solid #E8E4D5", borderRadius: 100, padding: "6px 14px" }}>{name}</span>
            ))}
          </div>
        </div>

        {/* Resources: compact, one line each */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", margin: 0 }}>Resources</p>
          <Link to="/resources" style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 500, color: "#5C7268", textDecoration: "none", display: "flex", alignItems: "center", gap: 4 }}>
            View all <ArrowRight size={13} />
          </Link>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {resources.map((r) => (
            <Link key={r.href} to={r.href} style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: "#112215", textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #E8E4D5" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#CD533B")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#112215")}>
              {r.title}
              <ArrowRight size={15} color="#8A9B92" />
            </Link>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .pt-grid { grid-template-columns: repeat(2,1fr) !important; } }
      `}</style>
    </section>
  );
}